export default __webpack_public_path__ + "static/media/nature.890f0b7f.jpeg";